import React, { useState } from "react";
import { Col, Modal, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import AddPolicyModal from "components/AddPolicyModal/AddPolicyModal";
import PolicyCard from "./components/PolicyCard/PolicyCard";

import { AddPolicyButton } from "./PolicySection.styles";
import Locale from "react-intl-universal";

const { confirm } = Modal;

const Policies = ({
  onAddPolicyButtonClick,
  policies,
  onEdit,
  onDelete,
  hideAddButton,
  disableRemoveButton,
  disableEditButton,
}) => {
  return (
    <Row gutter={[16, 16]}>
      {!hideAddButton && (
        <Col span={24}>
          <AddPolicyButton
            icon={<PlusOutlined />}
            onClick={onAddPolicyButtonClick}
          >
            {Locale.get("addNewAdvisee.policySection.addButton")}
          </AddPolicyButton>
        </Col>
      )}
      {policies.map((policy, index) => (
        <Col span={24} key={index}>
          <PolicyCard
            name={policy.name}
            company={policy.company.type}
            type={policy.type}
            premium={policy.premium}
            paymentMode={policy.paymentMode}
            medicalCard={policy.medicalCard}
            benefits={policy.benefits}
            remarks={policy.remarks}
            onEditClick={() => onEdit(index)}
            onDeleteClick={() => onDelete(index)}
            disableRemoveButton={disableRemoveButton}
            disableEditButton={disableEditButton}
          />
        </Col>
      ))}
    </Row>
  );
};

const PolicySection = ({
  policies = [],
  updatePolicies,
  isForProposal,
  hideAddButton,
  disableRemoveButton,
  disableEditButton,
}) => {
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [isEditPolicyClicked, setIsEditPolicyClicked] = useState(false);
  const [selectedPolicyIndex, setSelectedPolicyIndex] = useState(-1);

  const handleOnAddPolicyButtonClick = () => {
    setShowPolicyModal(true);
    setIsEditPolicyClicked(false);
    setSelectedPolicyIndex(-1);
  };

  const handleOnEditPolicyButtonClick = (index) => {
    if (!disableEditButton) {
      setIsEditPolicyClicked(true);
      setShowPolicyModal(true);
      setSelectedPolicyIndex(index);
    }
  };

  const handleOnDeletePolicyButtonClick = (index) => {
    if (!disableRemoveButton) {
      confirm({
        title: "Do you want to remove this policy?",
        okText: "Yes",
        onOk() {
          const newPolicies = [...policies];
          newPolicies.splice(index, 1);
          updatePolicies(newPolicies);
        },
        onCancel() {},
      });
    }
  };

  const handleOnAddPolicyModalOkButtonClick = (values) => {
    if (isEditPolicyClicked) {
      let editedPolicies = [...policies];
      editedPolicies[selectedPolicyIndex] = values;
      updatePolicies(editedPolicies);
      setIsEditPolicyClicked(false);
    } else {
      const newPolicies = [...policies, values];
      updatePolicies(newPolicies);
    }
    setShowPolicyModal(false);
  };

  const handleOnAddPolicyModalCancelButtonClick = () => {
    setShowPolicyModal(false);
  };

  return (
    <>
      <Policies
        onAddPolicyButtonClick={handleOnAddPolicyButtonClick}
        policies={policies}
        onEdit={handleOnEditPolicyButtonClick}
        onDelete={handleOnDeletePolicyButtonClick}
        hideAddButton={hideAddButton}
        disableRemoveButton={disableRemoveButton}
        disableEditButton={disableEditButton}
      />
      {showPolicyModal && (
        <AddPolicyModal
          defaultValues={
            selectedPolicyIndex > -1 && policies[selectedPolicyIndex]
          }
          onOk={handleOnAddPolicyModalOkButtonClick}
          onCancel={handleOnAddPolicyModalCancelButtonClick}
          visible={showPolicyModal}
          isForProposal={isForProposal}
        />
      )}
    </>
  );
};

export default PolicySection;
